import type { ReactNode } from "react";
import { href } from "../app/router.js";
import type { HelpGuideId } from "./guides.js";

/**
 * A small "How to…" link from a working screen into one Help centre guide.
 *
 * Typed on the guide id, so a link to a guide that does not exist is a compile
 * error rather than a "no such guide" page found by a user. Quiet on purpose —
 * a link, not a button or a banner — because it sits beside controls people
 * use every day and must not compete with them.
 */
export function HowToLink({
  guide,
  children,
}: {
  readonly guide: HelpGuideId;
  readonly children?: ReactNode;
}): ReactNode {
  return (
    <a className="how-to" href={href.helpGuide(guide)} data-help-guide={guide}>
      <span className="how-to__mark" aria-hidden="true">
        ?
      </span>
      {children ?? "How to…"}
    </a>
  );
}
